module.exports = __webpack_public_path__ + "146317be47713f55c9666110ad821f62.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/ABCMonumentGroteskSemi-Mono-Regular.woff
// module id = 35
// module chunks = 0 1